var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$auth.isAuthenticated)?_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":_vm.login}},[_vm._v(" Log In ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }